const getValue = props => ({
  ...props.theme,

  // use fixed height only when scrolling is enabled
  height: props.theme.scroll ? props.theme.height : 'auto',

  scroll: props.theme.scroll ? 'scroll' : 'auto',
  hideScroll: props.theme.hideScroll ? 'none' : 'auto',
  showShadow: props.theme.showShadow
    ? '0px 4px 4px rgba(0, 0, 0, 0.25)'
    : 'none',
  cardDisplay: props.theme.inline ? 'inline-flex' : 'flex',
  footerShadow: props.theme.footerShadow
    ? '0px -1px 20px rgba(0, 0, 0, 0.1)'
    : '',
  headerShadow: props.theme.headerShadow
    ? '0px 10px 15px rgba(0, 0, 0, 0.1)'
    : '',
});

export const getValueOf = key => props => getValue(props)[key];
